var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavHomeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nav__logo-box",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.321,
    height: 69.004,
    viewBox: "0 0 80.321 69.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "nav__logo-box-2",
    "data-name": "nav__logo-box",
    d: "M41.16,2.1,1,38.245H11.953V71.1H37.509V49.2h7.3V71.1H70.368V38.245H81.321Zm0,9.826L63.066,31.642V63.8H52.113V41.9H30.207V63.8H19.255V31.642Z",
    transform: "translate(-1 -2.1)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHomeLogo);
export default __webpack_public_path__ + "static/media/nav_home_logo.ad496c024d06d8dcae6ce74e7b509e0e.svg";
export { ForwardRef as ReactComponent };